import React from "react";
import { FaArrowUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

type ArrowButtonProps = {
  link: string;
  text: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
  iconColor?: string;
  iconBgColor?: string;
  className?: string;
};

const ArrowButton: React.FC<ArrowButtonProps> = ({
  link,
  text,
  bgColor,
  hoverBgColor,
  textColor,
  iconColor,
  iconBgColor,
  className = "",
}) => {
  const Navigate = useNavigate();
  return (
    <button
      onClick={() => Navigate(link)}
      className={`group relative ${textColor} text-md font-medium transition ease-in-out duration-300 py-3 px-9 ${bgColor} rounded-full overflow-hidden ${className}`}
    >
      <span
        className={`absolute inset-0 w-full h-full transition-all duration-300 ease-out transform -translate-x-full ${hoverBgColor} group-hover:translate-x-0`}
      ></span>
      <span className="relative mr-[2.5rem]">{text}</span>
      <div
        className={`absolute right-1 top-1/2 transform -translate-y-1/2 transition-transform duration-300 ease-out group-hover:translate-x-0 ${iconBgColor} p-3 rounded-full`}
      >
        <FaArrowUp className={`rotate-45 ${iconColor}`} />
      </div>
    </button>
  );
};

export default ArrowButton;
